import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user";
import workdata from "./modules/workdata";
import theme from "./modules/theme";
import schoolLogo from "./modules/schoolLogo";
import resource from "./modules/resource";
import globalCheck from "./modules/globalCheck";




Vue.use(Vuex);

// 用于标记是否由storage事件触发的状态更新
window.isUpdatingFromStorage = false;

const userStore = new Vuex.Store({
  modules: {
    user,
    workdata,
    theme,
    schoolLogo,
    resource,
    globalCheck,
  },
  getters,
  plugins: [
    createPersistedState({
      key: 'vuex', // 显式指定存储的key
      paths: ["user"],
      // 重写setState方法，在写入localStorage前设置标记
      setState: (key, state, storage) => {
        // 只有不是来自storage事件的更新才写入localStorage
        if (!window.isUpdatingFromStorage) {
          storage.setItem(key, JSON.stringify(state));
        }
      }
    }),
  ],
});
export default userStore;
